<template>
  <div class="answer-reward-custom">
    <div class="answer-reward" v-if="bindAward && !isFailed">
      <template v-if="!isOvertime">
        <template v-if="bindAward.boundStatus === 0">
          <div class="answer-reward-title">恭喜您抽中了{{ awardTitle }}</div>
          <reward-form />
        </template>
        <template v-else>
          <template v-if="!isPlatformAward">
            <div class="answer-reward-title">
              <template v-if="noNeedContactInfo">
                恭喜您抽中了{{ awardTitle }}
              </template>
              <template v-else>
                领取成功，获得奖品 {{ awardTitle }}
              </template>
              <template v-if="isQuality">
                <br />
                您的答卷不符合回收条件，发布者取消发放奖品
              </template>
              <template v-else-if="isPass">
                <br />
                您的答卷已审核通过，发布者正在发放奖品中，请耐心等待！
              </template>
              <template v-else-if="enableNetManualAudit">
                <br />
                此问卷已开启答卷审核通过后发放奖品
              </template>
            </div>
            <reward-result />
          </template>
          <template v-else>
            <div class="answer-reward-title">
                恭喜您抽中了{{ awardTitle }}
            </div>
            <div class="text-center cursor-pointer">
              <img :src="bindAward.awardImg" alt="" width="120" @click="onToPlatformAward(bindAward)"/>
            </div>
          </template>
        </template>
        <div class="publisher mt-3">
          <div class="publisher-item">
            <div class="publisher-label">
              <span>发布人 </span>
            </div>
            <div class="publisher-value">
              <span>{{ bindAward.awarderName }} {{ bindAward.awarderPhone }}</span>
            </div>
          </div>
          <div class="publisher-item" v-if="lotteryAwardPresentationDescribe">
            <div class="publisher-label">
              <span>领取方式 </span>
            </div>
            <div class="publisher-value">
              <div>
                {{ lotteryAwardPresentationDescribe }}
              </div>
            </div>
          </div>
        </div>
        <template v-if="isBindOtherAnswer">
          <div class="text-center mt-3 text-theme-black-650">
            此问卷已开启同一用户最多抽奖一次
          </div>
        </template>
      </template>
      <template v-else>
        <div class="text-center text-theme-black-650">
          很遗憾，您没有在15分钟内领取奖品，奖品已失效
        </div>
      </template>
    </div>
    <template v-else-if="!bindAward">
      <luck-draw-grid
          :before="beforeDraw"
          @confirm="onEnd"
          :draw-count="drawCount"
          :awards="lotteryAwards"
          :has-award="hasReward"
      />
    </template>
  </div>
</template>

<script>
import LuckDrawGrid from 'components/luck/LuckDrawGrid.vue'
import RewardForm from '@/components/reward/RewardForm'
import RewardResult from '@/components/reward/RewardResult'
import { AnswerStatus,BoundFailedType,BoundStatus } from 'dygc'
import { createPopup } from '@/assets/js/factory'
import AwardPopup from '@/components/popup/AwardPopup.vue'

export default {
  name: 'AnswerReward',
  components: { RewardResult, RewardForm, LuckDrawGrid },
  data() {
    return {
      drawCount: 1
    }
  },
  computed: {
    noNeedContactInfo(){
      return this.bindAward.noNeedContactInfo
    },
    hasReward(){
      return this.$bus.currentAwardData?.hasReward
    },
    isOvertime(){
      return this.bindAward.boundFailedType === BoundFailedType.OVERTIME
    },
    isFailed(){
      return this.bindAward.boundFailedType === BoundFailedType.MISS && this.bindAward.boundStatus === BoundStatus.FAILED
    },
    isReceive() {
      return this.$bus.isReceive
    },
    isPlatformAward(){
      return this.bindAward.lotteryCategory === 5
    },
    awardTitle() {
      const lotteryCategory = this.bindAward.lotteryCategory
      const award = this.lotteryAwards.find(item => item.gridNo === this.bindAward.gridNo)
      if(!award) return ''
      switch (lotteryCategory) {
        case 1:
        case 2:
        case 3:
        case 5:
          return award.awardName
        case 4:
          return `微信红包`
      }
    },
    lotteryAwardPresentationDescribe() {
      return this.$bus.lottery.lotteryAwardPresentationDescribe
    },
    lotteryAwards() {
      return this.$bus.lottery.lotteryAwards || []
    },
    enableNetManualAudit() {
      return this.$bus.survey.otherSetting.enableNetManualAudit
    },
    isQuality() {
      return this.$bus.overData.status === AnswerStatus.QUALITY
    },
    isPass() {
      return this.$bus.overData.status === AnswerStatus.PASS
    },
    bindAward() {
      return this.$bus.currentAwardData?.bindAward
    },
    isBindOtherAnswer() {
      return this.bindAward?.boundFailedType === BoundFailedType.OTHER_EXCESS //&& this.bindAward.boundStatus === 3
    },
    isOpenReward() {
      return this.$bus.isOpenReward
    }
  },
  methods: {
    onAward() {
      const url = this.$bus.getUrl(2)
      createPopup(AwardPopup, {
        isTest: !!this.$bus.params.isTest,
        url,
        needAuditFlag: !!this.enableNetManualAudit
      })
    },
    beforeDraw(start, end) {
      if (this.$bus.currentAwardData?.needAccountUserId && !this.$bus.params.accountUserId) {
        this.onAward()
        return
      }
      this.$bus.drawRewards().then(res => {
        end && end(res.data)
      })
      this.drawCount--
      start && start()
    },
    onToPlatformAward(bindAward){
      window.open(bindAward.extraInfo)
    },
    onEnd(award, bindAward) {
      if(bindAward.lotteryCategory === 5) {
        window.open(bindAward.extraInfo)
      }
      this.$bus.currentAwardData.bindAward = bindAward
      // this.$bus.overData.awardYuanAmount = bindAward.awardYuanAmount
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/mixin.scss';

.answer-reward {
  background-color: #ffd7d7;
  padding: 12px 32px;

  .publisher {
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    padding-top: 12px;

    .publisher-label {
      margin-right: 16px;
    }
  }

  .answer-reward-title {
    font-weight: 600;
    font-size: 14px;
    color: rgba(0, 0, 0, .85);
    line-height: 22px;
    text-align: center;
    margin-bottom: 12px;
  }

  @include useLabelItem('.publisher');
}
</style>
